import jsPDF from "jspdf";

const generateRffFormPDF = (inmateName, inmateId, rffFormData, title) => {
  const doc = new jsPDF({
    orientation: "portrait", // or "landscape"
    unit: "mm", // units: "pt", "mm", "cm", "in"
    format: [210, 420], // Custom page size: [width, height] in the specified unit
  });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginLeft = 10;
  const marginRight = 10;
  const sectionSpacing = 12;
  const lineSpacing = 8;
  let currentY = 30;

  const addWatermark = (doc, pageWidth, pageHeight) => {
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: 0.1 }));
    doc.setFontSize(100);
    doc.setFont("times", "normal");
    doc.setTextColor(180, 180, 180);
    doc.text("Inmate Inbox", pageWidth / 2, pageHeight / 2, {
      align: "center",
      angle: 30,
    });
    doc.restoreGraphicsState();
  };

  const drawHeader = () => {
    currentY = 30;
    doc.setFont("Times New Roman", "regular");
    doc.setFontSize(16);
    doc.text("Inmate Inbox", pageWidth / 2, 15, { align: "center" });
    doc.setFontSize(17);
    doc.setFont("Times New Roman", "bold");
    doc.text(title, pageWidth / 2, 25, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(255, 145, 2);
    doc.text("Name:", marginLeft, currentY);
    doc.setFont("helvetica", "normal");
    doc.text(inmateName || "N/A", marginLeft + 50, currentY);
    currentY += lineSpacing;

    doc.setFont("helvetica", "bold");
    doc.text("Resident ID:", marginLeft, currentY);
    doc.setFont("helvetica", "normal");
    doc.text(inmateId || "N/A", marginLeft + 50, currentY);
    currentY += sectionSpacing;

    doc.setTextColor(0, 0, 0);
    currentY -= 5;
    doc.line(marginLeft, currentY, pageWidth - marginRight, currentY);
    currentY += lineSpacing;
  };

  const checkPageOverflow = (rowHeight = 10) => {
    if (currentY + rowHeight > pageHeight - 20) {
      addWatermark(doc, pageWidth, pageHeight);
      doc.addPage();
      drawHeader();
    }
  };

  const groupedRequests = new Map();

  rffFormData?.forEach((curr) => {
    const key = curr.RequestForumThreadID;
    if (!groupedRequests.has(key)) groupedRequests.set(key, []);
    groupedRequests.get(key).push(curr);
  });

  drawHeader();

  // RFF Data Section - Iterate over grouped requests
  Array.from(groupedRequests.entries()).forEach(([key, group], index) => {
    checkPageOverflow(60);

    // Request Heading
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);

    const requestText = `Request: ${index + 1}`;
    doc.text(requestText, marginLeft, currentY);
    currentY += sectionSpacing;

    // Subheading
    const drawField = (label, value) => {
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text(label, marginLeft, currentY);
      doc.setFont("helvetica", "normal");

      const lines = doc.splitTextToSize(
        value || "N/A",
        pageWidth - marginLeft - marginRight - 50
      );
      lines.forEach((line, i) => {
        doc.text(line, marginLeft + 50, currentY + i * lineSpacing);
      });
      currentY += lines.length * lineSpacing;
    };

    drawField("Title:", group[0].Title);
    drawField("POD Code:", group[0].PODCode);
    drawField("Created On:", group[0].CreatedOn);
    currentY += 2;

    // Table Header
    const tableYStart = currentY;
    const headerHeight = 10;
    const colWidths = [80, 50, 50];
    doc.setFont("helvetica", "bold");
    doc.rect(
      marginLeft,
      tableYStart,
      colWidths.reduce((a, b) => a + b),
      headerHeight
    );
    doc.text("Request", marginLeft + 5, tableYStart + 7);
    doc.text("Posted By", marginLeft + colWidths[0] + 5, tableYStart + 7);
    doc.text("Sent Date Time", marginLeft + colWidths[0] + colWidths[1] + 5, tableYStart + 7);

    doc.line(
      marginLeft + colWidths[0],
      tableYStart,
      marginLeft + colWidths[0],
      tableYStart + headerHeight
    );
    doc.line(
      marginLeft + colWidths[0] + colWidths[1],
      tableYStart,
      marginLeft + colWidths[0] + colWidths[1],
      tableYStart + headerHeight
    );
    currentY += headerHeight;

    doc.setFont("helvetica", "normal");

    group.forEach((row) => {
      const requestText = row.Request || "N/A";
      const maxRequestWidth = colWidths[0] - 10; // 5px padding on each side
      const lineHeight = 5;
      const verticalPadding = 2; // Equal padding top and bottom for all cells

      // Split the text into lines
      const requestLines = doc.splitTextToSize(requestText, maxRequestWidth).map(line => line.trim()).filter(line => line.trim() !== '');
      const textHeight = requestLines?.length * lineHeight;

      // Calculate row height (ensures minimum padding matches headerHeight if needed)
      const rowHeight = Math.max(
        textHeight + (verticalPadding * 2), // Text height + equal padding
        headerHeight
      );

      checkPageOverflow(rowHeight);

      // Draw cell borders (unchanged)
      doc.rect(
        marginLeft,
        currentY,
        colWidths.reduce((a, b) => a + b),
        rowHeight
      );
      doc.line(
        marginLeft + colWidths[0],
        currentY,
        marginLeft + colWidths[0],
        currentY + rowHeight
      );
      doc.line(
        marginLeft + colWidths[0] + colWidths[1],
        currentY,
        marginLeft + colWidths[0] + colWidths[1],
        currentY + rowHeight
      );

      // Universal vertical position calculation
      const textY = currentY + verticalPadding + (lineHeight / 2); // Same for all lines

      // Draw justified request text
      requestLines.forEach((line, lineIndex) => {
        // const words = line.trim().split(/\s+/);
        // const lineTextWidth = doc.getTextWidth(words.join(''));
        // const spaceCount = words.length - 1;

        // if (spaceCount > 0 && lineIndex !== requestLines.length - 1) {
        //   const spaceWidth = (maxRequestWidth - lineTextWidth) / spaceCount;
        //   let cursorX = marginLeft + 5;

        //   words.forEach((word, wordIndex) => {
        //     doc.text(
        //       word,
        //       cursorX,
        //       textY + (lineIndex * lineHeight) // Uses consistent textY
        //     );
        //     if (wordIndex < spaceCount) {
        //       cursorX += doc.getTextWidth(word) + spaceWidth;
        //     }
        //   });
        // } else {
        doc.text(
          line,
          marginLeft + 5,
          textY + (lineIndex * lineHeight) // Uses consistent textY
        );
        // }
      });

      // Other columns (using the exact same vertical position)
      doc.text(
        row.PostedBy || "N/A",
        marginLeft + colWidths[0] + 5,
        textY // Same Y-position as first line of request text
      );
      doc.text(
        row.SentDateTime || "N/A",
        marginLeft + colWidths[0] + colWidths[1] + 5,
        textY // Same Y-position as first line of request text
      );

      currentY += rowHeight;
    });

    currentY += sectionSpacing;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Page ${i} of ${totalPages}`,
      pageWidth - marginRight - 30,
      pageHeight - 10
    );
    addWatermark(doc, pageWidth, pageHeight);
  }

  doc.save("Request_Forum_Form.pdf");
};

export default generateRffFormPDF;
